module.exports = __webpack_public_path__ + "static/media/ZISF.e8c14825.pdf";